import { useConnectorFlowRunner, type UseConnectorFlowRunnerResult } from '@/features/connectors/flows';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useWhatsappChannelFlow, type WhatsappFlowRole } from './useWhatsappChannelConnector';

type UseWhatsappConnectorFlowRunnerOptions = {
  audienceId: string | undefined;
  lang: string;
};

export type UseWhatsappConnectorFlowRunnerResult = UseConnectorFlowRunnerResult & {
  workspaceId: string;
  flow: ReturnType<typeof useWhatsappChannelFlow>['flow'];
  connectorFlowId: string | undefined;
  connectorInstanceId: string | undefined;
  isChannelLoading: boolean;
};

/**
 * WhatsApp-specific composer: resolve the flow for a role, then run prepare/create.
 * Keeps {@link useConnectorFlowRunner} channel-agnostic.
 */
export const useWhatsappConnectorFlowRunner = (
  role: WhatsappFlowRole,
  { audienceId, lang }: UseWhatsappConnectorFlowRunnerOptions
): UseWhatsappConnectorFlowRunnerResult => {
  const { id: workspaceId } = useWorkspace();
  const { flow, connectorInstanceId, isLoading: isChannelLoading } = useWhatsappChannelFlow(role);
  const connectorFlowId = flow?.id;

  const runner = useConnectorFlowRunner({
    workspaceId,
    audienceId,
    connectorFlowId,
    connectorInstanceId,
    lang,
  });

  return {
    ...runner,
    workspaceId,
    flow,
    connectorFlowId,
    connectorInstanceId,
    isChannelLoading,
  };
};
